import { Link } from 'react-router-dom';
import { articlesData } from '@/mocks/articles';

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20entertainment%20article%20illustration%20with%20red%20and%20gold%20decorative%20elements%2C%20elegant%20abstract%20background%2C%20soft%20warm%20lighting%2C%20professional%20editorial%20style%2C%20subtle%20gradient%20texture%2C%20gaming%20bonus%20theme&width=800&height=500&seq=article-guide-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20slot%20machine%20concept%20illustration%20with%20red%20and%20gold%20elements%2C%20elegant%20warm%20background%2C%20luxurious%20feeling%2C%20soft%20lighting%2C%20professional%20editorial%20style&width=800&height=500&seq=article-tips-02&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Experienced%20gamer%20sharing%20tips%20illustration%20with%20Chinese%20red%20and%20gold%20decorative%20elements%2C%20warm%20professional%20atmosphere%2C%20soft%20lighting%2C%20editorial%20style&width=800&height=500&seq=article-veteran-06&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Bright%20welcoming%20gaming%20registration%20concept%20illustration%20with%20Chinese%20red%20and%20gold%20elements%2C%20warm%20friendly%20atmosphere%2C%20soft%20lighting%2C%20clean%20editorial%20style&width=800&height=500&seq=article-newbie-07&orientation=landscape',
};

export default function ArticlesSection() {
  const latestArticles = articlesData.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">
              最新攻略文章
            </h2>
            <p className="text-foreground-500 text-sm">
              精选游戏攻略与彩金使用技巧，助您畅玩无忧
            </p>
          </div>
          <Link
            to="/article/1"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.id] || articleImages[1]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="flex items-center gap-1 text-foreground-400 text-xs">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/article/1"
            className="inline-flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors duration-200"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}